import * as yup from 'yup';
import { MarketingHeader } from '../MarketingHeader';
import { linkSchema, nullableImageFromCMSSchema } from '../schemas';
import { schema as slideoutMenuLinkSchema } from './slideout_menu_link';
import { schema as slideDownMenuLinkSchema } from './slide_down_menu_link';
import { schema as referAFriendButtonSchema } from './refer_a_friend_button';
import { schema as navLinkGroupSchema } from './nav_link_group';
import { schema as discountBannerSchema } from './discount_banner';
import { schema as rotatingPromoBarSchema } from './rotating_promo_bar';

export const component = MarketingHeader;

export const schema = yup
  .object({
    logoImg: nullableImageFromCMSSchema,
    logoUrl: yup.string().required(),
    logoSrText: yup.string().required(),
    links: yup.array(
      yup.lazy(item => {
        if (item.component === 'slideout_menu_link')
          return slideoutMenuLinkSchema;
        if (item.component === 'slide_down_menu_link')
          return slideDownMenuLinkSchema;
        if (item.component === 'refer_a_friend_button')
          return referAFriendButtonSchema;
        return linkSchema;
      }),
    ),
    mobileLinks: yup.array(
      yup.lazy(item => {
        if (item.component === 'nav_link_group') return navLinkGroupSchema;
        if (item.component === 'slideout_menu_link')
          return slideoutMenuLinkSchema;
        if (item.component === 'slide_down_menu_link')
          return slideDownMenuLinkSchema;
        if (item.component === 'refer_a_friend_button')
          return referAFriendButtonSchema;
        return linkSchema;
      }),
    ),
    discountBannerProps: discountBannerSchema,
    rotatingPromoBarProps: rotatingPromoBarSchema,
    bgColor: yup.string(),
    fontColor: yup.string(),
    menuBgColor: yup.string(),
    ctaButton: yup.array().of(
      yup.object().shape({
        mobileCTAText: yup.string(),
        desktopCTAText: yup.string(),
        ctaTarget: yup.string(),
        ctaVariant: yup.string(),
        headerText: yup.string().nullable(),
        testName: yup.string().nullable(),
      }),
    ),
    mobileCtaButton: yup.array().of(
      yup.object().shape({
        mobileCTAText: yup.string(),
        desktopCTAText: yup.string(),
        ctaTarget: yup.string(),
        ctaVariant: yup.string(),
        headerText: yup.string().nullable(),
        testName: yup.string().nullable(),
      }),
    ),
    hideLoginLinkMobile: yup.bool(),
    hideLoginLinkDesktop: yup.bool(),
    mobileLogo: nullableImageFromCMSSchema,
    closeButtonPosition: yup.string().oneOf(['left', 'right']),
  })
  .transform(value => {
    return {
      logoImg: value.logoImg || null,
      logoUrl: value.logo_target.url || value.logo_target?.cached_url || '/',
      logoSrText: value.logo_sr_text || 'Ollie Home',
      links: value.left_links || value.navigation_links,
      mobileLinks:
        value.mobile_links?.length > 0
          ? value.mobile_links
          : value.navigation_links,
      discountBannerProps: value.discount_banner?.[0],
      rotatingPromoBarProps: value.rotating_promo_bar?.[0],
      ctaButton: value.cta_button?.map(cta => ({
        mobileCTAText: cta.mobile_cta_text,
        desktopCTAText: cta.desktop_cta_text,
        ctaTarget: cta.cta_target?.url,
        ctaVariant: cta.cta_variant || undefined,
        testName: cta.test_name || null,
        component: cta.component,
        headerText: cta.header_text || undefined,
        variants: cta.variants || [],
      })),
      mobileCtaButton: value.mobile_cta_button?.map(cta => ({
        mobileCTAText: cta.mobile_cta_text,
        desktopCTAText: cta.desktop_cta_text,
        ctaTarget: cta.cta_target?.url,
        ctaVariant: cta.cta_variant || undefined,
        testName: cta.test_name || null,
        component: cta.component,
        headerText: cta.header_text || undefined,
        variants: cta.variants || [],
      })),
      menuBgColor: value.menu_background_color || undefined,
      bgColor: value.background_color || undefined,
      fontColor: value.font_color || undefined,
      hideLoginLinkMobile: value.hide_login_link_mobile,
      hideLoginLinkDesktop: value.hide_login_link_desktop,
      mobileLogo: value.mobile_logo || null,
      closeButtonPosition: value.close_button_position || undefined,
    };
  });
